// src/components/DialogProvider.tsx
// ALPHA: Global Dialog Provider for CustomDialog

import React, { ReactNode } from 'react';
import { useDialog } from './CustomDialog';

interface DialogProviderProps {
  children: ReactNode;
}

/**
 * Dialog Provider
 *
 * Provides global dialog functionality to the entire app.
 * Components can use showAlert, showConfirm, showPrompt helper functions.
 *
 * Usage in App.tsx:
 * <DialogProvider>
 *   <YourApp />
 * </DialogProvider>
 */
export const DialogProvider: React.FC<DialogProviderProps> = ({ children }) => {
  const { dialogComponent } = useDialog();

  return (
    <>
      {children}
      {dialogComponent}
    </>
  );
};

export default DialogProvider;
